import { render, staticRenderFns } from "./RaceDetails.vue?vue&type=template&id=1edd4e8f&"
import script from "./RaceDetails.vue?vue&type=script&lang=js&"
export * from "./RaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./RaceDetails.vue?vue&type=style&index=0&id=1edd4e8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports